export const categories = [
  {
    id: 1,
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    subtitle: 'Sneakers & Footwear',
    items: '320+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trendy%20white%20sneakers%20placed%20on%20a%20polished%20concrete%20floor%20with%20urban%20street%20art%20mural%20in%20soft%20focus%20background%2C%20afternoon%20sunlight%20casting%20dramatic%20diagonal%20shadows%2C%20contemporary%20streetwear%20editorial%20photography%2C%20cool%20grey%20and%20white%20palette%20with%20subtle%20graffiti%20color%20accents%2C%20high%20detail%20texture%20on%20shoe%20materials&width=600&height=750&seq=cat-shoes-v2-01&orientation=portrait',
  },
  {
    id: 2,
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    subtitle: 'Cozy Streetwear',
    items: '210+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20pastel%20pink%20oversized%20hoodie%20draped%20over%20a%20velvet%20tufted%20armchair%20in%20a%20cozy%20reading%20nook%2C%20warm%20lamp%20glow%20creating%20intimate%20atmosphere%2C%20lifestyle%20fashion%20photography%20with%20romantic%20blush%20tones%2C%20plush%20fabric%20texture%20clearly%20visible%2C%20dreamy%20and%20feminine%20editorial%20aesthetic%20with%20floral%20accent%20nearby&width=600&height=750&seq=cat-hoodies-v2-02&orientation=portrait',
  },
  {
    id: 3,
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    subtitle: 'Essential Tees',
    items: '280+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20graphic%20t-shirts%20in%20bold%20colors%20hanging%20on%20a%20modern%20matte%20black%20clothing%20rack%20against%20a%20bright%20white%20studio%20wall%2C%20crisp%20professional%20lighting%20with%20clean%20sharp%20shadows%2C%20high%20contrast%20editorial%20product%20photography%2C%20rainbow%20palette%20of%20coral%20red%20emerald%20green%20and%20cobalt%20blue%20tees%2C%20energetic%20youthful%20aesthetic&width=600&height=750&seq=cat-tshirts-v2-03&orientation=portrait',
  },
  {
    id: 4,
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    subtitle: 'Outerwear Collection',
    items: '190+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20leather%20bomber%20jacket%20styled%20on%20a%20mannequin%20against%20an%20industrial%20exposed%20brick%20wall%20with%20metal%20pipe%20details%2C%20dramatic%20side%20lighting%20from%20a%20warehouse%20window%2C%20moody%20editorial%20fashion%20photography%20with%20warm%20amber%20and%20rust%20tones%2C%20rich%20leather%20grain%20texture%20highlighted%2C%20urban%20loft%20aesthetic&width=600&height=750&seq=cat-jackets-v2-04&orientation=portrait',
  },
  {
    id: 5,
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    subtitle: 'Bottoms & Denim',
    items: '240+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Distressed%20denim%20jeans%20and%20tailored%20chino%20shorts%20artfully%20arranged%20on%20a%20sunlit%20terracotta%20tiled%20floor%20with%20potted%20monstera%20plant%20in%20corner%2C%20Mediterranean%20courtyard%20ambiance%2C%20warm%20golden%20afternoon%20light%20through%20arched%20window%2C%20relaxed%20lifestyle%20fashion%20photography%2C%20earthy%20rust%20orange%20and%20indigo%20blue%20contrast&width=600&height=750&seq=cat-pants-v2-05&orientation=portrait',
  },
  {
    id: 6,
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    subtitle: 'Caps & Beanies',
    items: '150+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20caps%20and%20knitted%20beanies%20placed%20on%20fresh%20green%20grass%20in%20a%20sun-dappled%20garden%20setting%2C%20natural%20outdoor%20morning%20light%20filtering%20through%20leaves%2C%20casual%20lifestyle%20accessory%20photography%2C%20vibrant%20spring%20green%20background%20with%20bokeh%20effect%2C%20relaxed%20weekend%20outdoor%20vibe&width=600&height=750&seq=cat-headwear-v2-06&orientation=portrait',
  },
  {
    id: 7,
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    subtitle: 'Matching Outfits',
    items: '170+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coordinated%20two-piece%20matching%20set%20displayed%20elegantly%20on%20a%20minimalist%20grey%20toned%20mannequin%20against%20a%20subtle%20gradient%20backdrop%20transitioning%20from%20soft%20dove%20grey%20to%20pearl%20white%2C%20sophisticated%20studio%20lighting%20with%20gentle%20rim%20highlights%2C%20high%20fashion%20editorial%20photography%2C%20monochrome%20grey%20palette%20with%20refined%20tailored%20silhouette&width=600&height=750&seq=cat-sets-v2-07&orientation=portrait',
  },
  {
    id: 8,
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    subtitle: 'Essentials',
    items: '130+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20pieces%20neatly%20arranged%20on%20a%20lavender%20colored%20satin%20fabric%20surface%20with%20delicate%20dried%20flower%20petals%20scattered%20around%2C%20gentle%20diffused%20window%20light%20creating%20ethereal%20atmosphere%2C%20intimate%20lifestyle%20product%20photography%2C%20calming%20lilac%20and%20soft%20white%20color%20palette%2C%20romantic%20and%20clean%20composition&width=600&height=750&seq=cat-underwear-v2-08&orientation=portrait',
  },
  {
    id: 9,
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    subtitle: 'Sports & Teamwear',
    items: '160+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20sports%20jersey%20laid%20flat%20on%20vibrant%20green%20artificial%20turf%20field%20with%20white%20field%20markings%20visible%2C%20bright%20stadium%20lighting%20creating%20crisp%20dynamic%20shadows%2C%20energetic%20sportswear%20editorial%20photography%2C%20bold%20team%20colors%20of%20red%20navy%20and%20white%2C%20athletic%20performance%20fabric%20texture%20clearly%20visible&width=600&height=750&seq=cat-jersey-v2-09&orientation=portrait',
  },
  {
    id: 10,
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    subtitle: 'Watches & Jewelry',
    items: '200+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20wristwatches%20and%20minimal%20gold%20jewelry%20pieces%20displayed%20on%20a%20polished%20dark%20charcoal%20marble%20slab%20with%20subtle%20golden%20veining%2C%20dramatic%20spotlight%20reflections%20creating%20luxurious%20ambiance%2C%20high%20end%20jewelry%20editorial%20photography%2C%20sophisticated%20black%20and%20gold%20color%20scheme%2C%20premium%20retail%20display%20aesthetic&width=600&height=750&seq=cat-accessories-v2-10&orientation=portrait',
  },
  {
    id: 11,
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    subtitle: 'Backpacks & Totes',
    items: '140+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20leather%20backpack%20and%20canvas%20tote%20bag%20placed%20on%20a%20rustic%20wooden%20bench%20inside%20a%20cozy%20cabin%20interior%20with%20exposed%20log%20walls%2C%20warm%20fireplace%20glow%20in%20background%20creating%20golden%20ambiance%2C%20lifestyle%20accessory%20photography%2C%20rich%20cognac%20brown%20and%20forest%20green%20tones%2C%20adventurous%20outdoor%20travel%20aesthetic&width=600&height=750&seq=cat-bags-v2-11&orientation=portrait',
  },
  {
    id: 12,
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    subtitle: 'Leather & Casual',
    items: '100+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belts%20displayed%20on%20a%20weathered%20oak%20workbench%20in%20a%20artisan%20leather%20workshop%2C%20tools%20and%20leather%20scraps%20scattered%20naturally%20in%20background%2C%20warm%20tungsten%20task%20lighting%20highlighting%20stitching%20details%2C%20craftsmanship%20editorial%20photography%2C%20rich%20saddle%20brown%20and%20aged%20brass%20tones%2C%20authentic%20maker%20studio%20atmosphere&width=600&height=750&seq=cat-belts-v2-12&orientation=portrait',
  },
  {
    id: 13,
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    subtitle: 'Fragrances',
    items: '90+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottle%20with%20deep%20amber%20colored%20fragrance%20placed%20on%20a%20reflective%20black%20glass%20surface%20with%20crystal%20prisms%20catching%20scattered%20light%2C%20moody%20dark%20atmospheric%20setting%20with%20soft%20golden%20backlight%20creating%20mysterious%20glow%2C%20premium%20fragrance%20editorial%20photography%2C%20rich%20cognac%20amber%20and%20obsidian%20black%20palette%2C%20sophisticated%20boudoir%20aesthetic&width=600&height=750&seq=cat-perfumes-v2-13&orientation=portrait',
  },
  {
    id: 14,
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    subtitle: 'More Discoveries',
    items: '180+',
    imageUrl: 'https://readdy.ai/api/search-image?query=Eclectic%20colorful%20collection%20of%20fashion%20accessories%20sunglasses%20scarves%20and%20small%20leather%20goods%20scattered%20playfully%20on%20a%20bright%20turquoise%20painted%20wooden%20table%2C%20cheerful%20morning%20sunlight%20streaming%20in%2C%20vibrant%20bohemian%20lifestyle%20photography%2C%20rainbow%20palette%20of%20coral%20yellow%20turquoise%20and%20magenta%2C%20joyful%20maximalist%20flat%20lay%20with%20tropical%20leaf%20accents&width=600&height=750&seq=cat-other-v2-14&orientation=portrait',
  },
];